import logger from '3-foundation/Logging/logger';
import { mapFirstImage } from '../DataTypes/imageMapper';
import { mapFirstLink } from '../DataTypes/linkMapper';
import { mapFirstTheme } from '../DataTypes/themeMapper';
import { mapFirstVideo } from '../DataTypes/videoMapper';

interface Props {
	content: {
		contentType: 'heroCard';
		properties: {
			kicker: string;
			heading: string;
			text: string | null;
			link: Umbraco.Link[];
			image: Umbraco.Image[];
			altText: string;
			video: Umbraco.Video[];
		};
	};
	settings: {
		properties: {
			theme: { theme: Umbraco.TreeNode }[];
			layout: 'Small Media' | 'Full Width Center';
		};
	};
}

export const mapHeroCard = ({ content, settings }: Props): Content.HeroCard => {
	const { kicker, heading, text, link, image, altText, video } = content?.properties ?? {};
	const { theme, layout } = settings?.properties ?? {};

	try {
		return {
			documentType: content?.contentType,
			content: {
				kicker: kicker ?? null,
				heading,
				text: text ?? null,
				link: mapFirstLink(link) ?? null,
				video: mapFirstVideo(video) ?? null,
				image: mapFirstImage(image),
				altText: altText ?? null,
			},
			settings: {
				properties: {
					theme: mapFirstTheme(theme),
					layout: layout ?? null,
				},
			},
		};
	} catch (e) {
		logger.error(`Could not map HeroCard \nCause: ${e}`);
		throw new Error(`Could not map HeroCard \nCause: ${e}`, { cause: e });
	}
};
